export default "/images/vendor/@coreui/icons/svg/flag/cif-to.svg?52b5b873ba31ce158bbafa6308dcee45";